import * as React from 'react';
import { UserBanner } from "./common/UserBanner";
import { BenefitsList } from './common/BenefitsList';
import { FAQSection } from './common/FAQSection';
import { useCallback, useEffect, useState } from "react";
import { MembershipCard } from "./MembershipCard";
import { membershipTypes,contactInfo, userInfo, benefits, faqs } from './MembershipLavelData';
import { Link } from 'react-router-dom';
import MembershipProgress from './common/MembershipProgress';
 
export const MembershipLavelPage: React.FC = () => {
  const [merchantDetailsInfo, setMerchantDetailsInfo] = useState<any>();
  return (
    <div className="flex overflow-hidden flex-col items-center bg-stone-50 pb-[50px] max-md:pb-24">
     <UserBanner
        userId={merchantDetailsInfo?.walletId || "JM 5421547"}
        userName={
          merchantDetailsInfo?.merchantPersonalDetail?.name || "New User"
        }
        membershipInfo={{
          title: "Welcome to Jachai Seller Center",
          description: "Explore US of wih a new seller and more benefits",
          ctaText: <Link to="/membership-upgrade">Explore</Link>,
        }}
        verificationStatus="our team is review your Documents. Expect a response within 72 hours. Thank you for your patience."
      />

      <div className="flex flex-wrap gap-5 justify-between py-2.5 pr-5 pl-20 mt-8 max-w-full font-bold bg-orange-100 rounded-xl shadow-sm w-[970px] max-md:pl-5">
        <div className="flex gap-5 text-zinc-800">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/e11d4dc72243d4ed334d887976b143366fad56aa892f71558b2f2de3a0359604?placeholderIfAbsent=true&apiKey=fca3da21012743ce8f0bf226c9b50cd7"
            alt="User level icon"
            className="object-contain shrink-0 w-20 rounded-none aspect-square"
          />
          <div className="flex flex-col self-start">
            <div className="self-start text-sm font-medium">
              You are a Jachai
            </div>
            <div className="mt-1 text-base max-md:mr-1.5">BRONZE USER</div>
            <div className="flex gap-0.5 mt-1 text-xs">
              <div className="grow">POINTS HISTORY</div>
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/2bdb458c944a42109462caad7fe934c95f5d55dd0ddc1f1936cd3e0837d6ff41?placeholderIfAbsent=true&apiKey=fca3da21012743ce8f0bf226c9b50cd7"
                alt=""
                className="object-contain shrink-0 w-4 aspect-square"
              />
            </div>
          </div>
        </div>
        <Link to="/membership">
        <button className="self-start px-5 py-1.5 mt-1.5 text-sm text-center text-cyan-700 whitespace-nowrap bg-white rounded-md max-md:pl-5">
          Update
        </button>
        </Link>
      </div>
      <div className="flex flex-col py-7 pr-1.5 mt-6 max-w-full text-sm font-medium text-black bg-white rounded-xl shadow-sm w-[970px]">
      <MembershipProgress/>
        <div className="self-start mt-3 ml-6 max-md:ml-2.5">
          Redeeming points won't affect your progress to the next level
        </div>
      </div>
      <BenefitsList benefits={benefits} />
      <FAQSection faqs={faqs} />
    </div>
  );
};

export default MembershipLavelPage;